// ============================================================
// NAVEGACION
// ------------------------------------------------------------
// REGLA UNICA: aqui solo entran destinos que EXISTEN.
//
// El menu tenia 7 items (Finance, Credit, AI, Software, Rewards,
// Learn, About) apuntando a anclas inexistentes. Cinco de esas
// verticales no tienen ni una pagina escrita. Un menu que promete
// seis secciones y entrega una destruye la confianza, que es
// justamente lo que Blinkblis vende.
//
// Cuando Finance tenga 3 articulos, Finance vuelve al menu.
// Se gana el lugar, no se reserva.
// ============================================================

import type { Lang } from '../offers/config'

export type NavItem = {
  label: Record<Lang, string>
  path: string
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: { es: 'Credito', en: 'Credit' },
    path: '/oferta/credito',
  },
  {
    label: { es: 'Metodologia', en: 'Methodology' },
    path: '/metodologia',
  },
  {
    label: { es: 'Como trabajamos', en: 'How we work' },
    path: '/divulgacion-de-afiliados',
  },
]

// ============================================================
// FOOTER
// El footer si puede listar mas, porque nadie espera que el pie
// de pagina sea un indice de contenido — pero tampoco enlaza a
// nada que no exista. null = no se muestra.
// ============================================================

// Orden en i18n: 0 Finance · 1 Credit · 2 AI · 3 Software · 4 Rewards
export const FOOTER_PLATFORM: (string | null)[] = [
  null, // Finance   — sin contenido
  '/oferta/credito', // Credit    — la unica viva
  null, // AI        — sin contenido
  null, // Software  — sin contenido
  null, // Rewards   — sin contenido
]

// Orden en i18n: 0 About · 1 Careers · 2 Contact · 3 Press
export const FOOTER_COMPANY: (string | null)[] = [
  '/estandares-editoriales', // About -> quienes somos se explica aqui
  null, // Careers
  'mailto:insights@blinkblis.com', // Contact
  null, // Press
]

// Orden en i18n: 0 Editorial Standards · 1 Methodology
// 2 Affiliate Disclosure · 3 Privacy · 4 Terms · 5 Contact
export const FOOTER_LEGAL: (string | null)[] = [
  '/estandares-editoriales',
  '/metodologia',
  '/divulgacion-de-afiliados',
  '/privacidad',
  '/terminos',
  'mailto:insights@blinkblis.com',
]

export const isExternal = (path: string) =>
  path.startsWith('mailto:') || path.startsWith('http') || path.startsWith('/#')
